import script from "./MySelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./MySelect.vue?vue&type=script&setup=true&lang=ts"

import "./MySelect.vue?vue&type=style&index=0&id=ba828abc&lang=scss"

const __exports__ = script;

export default __exports__